/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

export default {
    'searchList': {
        'searchTxt': [{
            'name': '发车单号',
            'value': 'dispatchNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '创建时间',
            'value': 'createTime',
            'startTime': 'beginDate',
            'endTime': 'endDate',
            'startPlaceholder': '创建开始日期',
            'endPlaceholder': '创建结束日期',
            'type': 'time',
            'timeNum': 3,
            'unfold': true,
            'span': 7
        }, {
            'name': '状态',
            'value': 'status',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'optionNum': 'S_F_FLAG',
            'multiple': false,
            'options': []
        }],
        'unfoldState': false,
        'advancedBtn': true
    },
    'table':
    {
        'clickState': false,
        'selectBtn': true,
        'height': 400,
        'columns': [
            {
                'label': '发车单号',
                'prop': 'dispatchNo',
                'width': '148px',
                'sort': true
            },
            {
                'label': '发车平台',
                'prop': 'siteName',
                'width': '100px',
                'sort': true
            },
            {
                'label': '发货地省份',
                'prop': 'senderProvinceName',
                'width': '86px',
                'sort': true
            },
            {
                'label': '发货地城市',
                'prop': 'senderCityName',
                'width': '86px',
                'sort': true
            },
            {
                'label': '发货地区县',
                'prop': 'senderDistrictName',
                'width': '86px',
                'sort': true
            },
            {
                'label': '目的地省份',
                'prop': 'receiverProvinceName',
                'width': '86px',
                'sort': true
            },
            {
                'label': '目的地城市',
                'prop': 'receiverCityName',
                'width': '88px',
                'sort': true
            },
            {
                'label': '目的地区县',
                'prop': 'receiverDistrictName',
                'width': '86px',
                'sort': true
            },
            {
                'label': '司机',
                'prop': 'driver',
                'width': '70px',
                'sort': true
            },
            {
                'label': '手机',
                'prop': 'driverContactWay',
                'width': '102px',
                'sort': true
            },
            {
                'label': '车牌',
                'prop': 'vehicleCard',
                'width': '82px',
                'sort': true
            },
            {
                'label': '运输成本',
                'prop': 'allFreight',
                'sort': true
            },
            {
                'label': '商品中文名称',
                'prop': 'itemName',
                'width': '120px',
                'sort': true
            },
            {
                'label': '第三方单号',
                'prop': 'thirdNum',
                'width': '90px',
                'sort': true
            },
            {
                'label': '状态',
                'prop': 'statusText',
                'width': '50px',
                'sort': true
            },
            {
                'label': '返回结果',
                'prop': 'result',
                'width': '106px',
                'sort': true
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'width': '148px',
                'sort': true
            }],
        'action': [
            {
                'type': 'text',
                'label': '编辑',
                'size': 'mini',
                'event': 'edit'
            }
        ],
        'leftOperation': true
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50]
    },
    searchTotalTitle: [
        {
            'name': '服务平台',
            'value': 'siteName',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' },
                { 'prop': 'escoCompanyNo', 'value': '服务平台编码' }
            ],
            'tableConfig': [
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' },
                { 'prop': 'escoCompanyNo', 'value': '服务平台编码' }
            ],
            'advanceUrl': '/searchPlatform',
            'cbParams': ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
            'advanceCode': 'advanceCode'
        },
        {
            'name': '司机',
            'type': 'advance',
            'value': 'driver',
            'advanceConfig': [
                { 'prop': 'name', 'value': '司机' },
                { 'prop': 'encuMobile', 'value': '电话' }

            ],
            'tableConfig': [
                { 'prop': 'name', 'value': '司机' },
                { 'prop': 'encuMobile', 'value': '电话' }
            ],
            'advanceUrl': 'suDriver/searchByConditions',
            'cbParams': [
                'name#driver', 'encuMobile#driverContactWay', 'cardId#driverIdentity'
            ]
        }
    ]
};
